import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";

export default function ModalIngresosActividad(props) {
  const op = require("@/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [anio, setAnio] = useState(anioActual);

  const imprimirReporte = () => {
    try {
      window.open(
        `${op.reportes}/actividadeconomica?reporte=List_Ingresos_Actividad&ANIO=${anio}&EFISCAL=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };

  const salir = () => {
    props.setTabla();
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3
          className=" fw-bold text-light m-0"
          style={{
            fontSize: "1.2rem",
          }}
        >
          Impresión de Ingresos x Tipos de Ingresos
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-center">
          <div className="col-md-12 d-flex justify-content-center">
            <div className="input-group input-group-sm m-0 col-md-4">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Año:
              </span>
              <select
                className="form-select form-select-sm"
                value={anio}
                onChange={(e) => setAnio(e.target.value)}
              >
                {anios &&
                  anios.map((e) => (
                    <option key={e} value={e}>
                      {e}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-primary col-md-3"
        >
          <i className="fas fa-print" /> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close" /> Salir
        </button>
      </Modal.Footer>
    </Modal>
  );
}
